<div class="flex gap-6 me-44">
  <h3 class="overflow-hidden text-ellipsis line-clamp-1">Købshistorik • {{ customerName() }}</h3>
  <button mat-flat-button (click)="goBackToCustomerDataPage()" class="btn-go-back">
    Tilbage til kundedata
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none" class="inline-block">
      <path
        d="M5 9.5L1 5.5M1 5.5L5 1.5M1 5.5H9C10.0609 5.5 11.0783 5.92143 11.8284 6.67157C12.5786 7.42172 13 8.43913 13 9.5C13 10.5609 12.5786 11.5783 11.8284 12.3284C11.0783 13.0786 10.0609 13.5 9 13.5H7"
        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</div>
<div class="flex items-center gap-2">
  <p class="!mb-0">Vis som:</p>
  <mat-radio-group [value]="viewType()" (change)="changeViewType($event.value)">
    <mat-radio-button value="lineItems" class="me-4">Varelinjer</mat-radio-button>
    <mat-radio-button value="orders">Bonner / ordrer</mat-radio-button>
  </mat-radio-group>
</div>
<app-card [withoutHeader]="true">
  @if (loadingOrders()) {
    <app-loading-icon [grey]="true"/>
  } @else if (orderHistory()?.totalItems === 0) {
    <div class="flex flex-col items-center justify-center h-64">
      <img ngSrc="assets/sad-bottle.png" width="51" height="100" alt="Sad bottle"/>
      <p>Der er ingen købshistorik for denne kunde</p>
    </div>
  } @else if (viewType() === 'lineItems') {
    <div class="overflow-y-auto" appDragScroll>
      <app-order-line-item-table [lineItems]="lineItems()" [totalItems]="orderHistory()?.totalItems ?? 1"
                                 [pageIndex]="pageIndex()" (pageChange)="changePage($event)"/>
    </div>
  } @else if (viewType() === 'orders') {
    <app-order-table [orders]="orderHistory()?.items" [totalItems]="orderHistory()?.totalItems ?? 1"
                     [pageIndex]="pageIndex()" (pageChange)="changePage($event)"/>
  }
</app-card>
